import { render, staticRenderFns } from "./AuthorDetail.vue?vue&type=template&id=93c054ac&scoped=true&"
import script from "./AuthorDetail.vue?vue&type=script&lang=js&"
export * from "./AuthorDetail.vue?vue&type=script&lang=js&"
import style0 from "./AuthorDetail.vue?vue&type=style&index=0&id=93c054ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c054ac",
  null
  
)

export default component.exports